import { globalPanelData } from "../panel/data/PanelData";

export default class InstallationUtils {
  private static initPromise: Promise<void> | undefined;

  static init(): Promise<void> {
    if (this.initPromise) return this.initPromise;

    const promise = (async () => {
      const { loadPanelDataFromProject } = await import("../panel/data/PanelDataImport");
      await loadPanelDataFromProject();
      globalPanelData.initCallbacks();
      await (window as any).startupWebSocket();
      await globalPanelData.registerDatapointsInstallation();
    })();

    this.initPromise = promise;
    void promise.then(
      () => {
        if (this.initPromise === promise) this.initPromise = undefined;
      },
      () => {
        if (this.initPromise === promise) this.initPromise = undefined;
      },
    );

    return promise;
  }

  static async stop() {
    (window as any).closeWebSocket();
  }
}
